import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  input {
    height: 40px;
  }

  .buttonContainer {
    display: flex;
    gap: 20px;

    button {
      width: 130px;
    }
  }
`;
